import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import MuiAvatar from '@mui/material/Avatar';

// assetss
import PersonIcon from '@mui/icons-material/Person';

// ==============================|| AVATAR ||============================== //

const Avatar = React.forwardRef((props, ref) => {
    const theme = useTheme();
    const { color, outline, size, sx, avatar, ...others } = props;

    const colorSX = color && !outline && { color: theme.palette.background.paper, bgcolor: `${color}.main` };
    const outlineSX = outline && {
        color: color ? `${color}.main` : `primary.main`,
        bgcolor: theme.palette.background.paper,
        border: '2px solid',
        borderColor: color ? `${color}.main` : `primary.main`
    };

    let sizeSX = {};
    switch (size) {
        case 'badge':
            sizeSX = {
                width: theme.spacing(3.5),
                height: theme.spacing(3.5)
            };
            break;
        case 'xs':
            sizeSX = {
                width: theme.spacing(4.25),
                height: theme.spacing(4.25)
            };
            break;
        case 'sm':
            sizeSX = {
                width: theme.spacing(5),
                height: theme.spacing(5)
            };
            break;
        case 'lg':
            sizeSX = {
                width: theme.spacing(9),
                height: theme.spacing(9)
            };
            break;
        case 'xl':
            sizeSX = {
                width: theme.spacing(10.25),
                height: theme.spacing(10.25)
            };
            break;
        case 'md':
            sizeSX = {
                width: theme.spacing(7.5),
                height: theme.spacing(7.5)
            };
            break;
        default:
            sizeSX = {};
    }

    if (avatar)
        return (
            <MuiAvatar
                sx={{ ...colorSX, ...outlineSX, ...sizeSX, ...sx }}
                ref={ref}
                src={avatar ? `${process.env.REACT_APP_API}/${avatar || ''}` : undefined}
                {...others}
            />
        );

    return (
        <MuiAvatar sx={{ ...colorSX, ...outlineSX, ...sizeSX, ...sx }} ref={ref} {...others}>
            <PersonIcon fontSize="small" />
        </MuiAvatar>
    );
});

Avatar.propTypes = {
    color: PropTypes.string,
    outline: PropTypes.bool,
    size: PropTypes.string,
    sx: PropTypes.object,
    avatar: PropTypes.string
};

export default Avatar;
